import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-qr-dialog',
    templateUrl: './qr-dialog.component.html',
    styleUrls: ['./qr-dialog.component.scss'],
    standalone: false
})
export class QrDialogComponent implements OnInit {
  qrValue: string;
  headerText = (localStorage.getItem('lang') === 'es') ? 'Código QR' : 'QR Code';
  closeText = (localStorage.getItem('lang') === 'es') ? 'CERRAR' : 'CLOSE';

  constructor(public dialogRef: MatDialogRef<QrDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, ) {
                dialogRef.disableClose = true;
              }

  ngOnInit(): void {
    this.qrValue = this.data.value;
  }

  close() {
    this.dialogRef.close();
  }

}
